import React from 'react';
import { date } from '@/libs';

export const TooltipView: React.FunctionComponent<{ name: string; date: string }> = ({ name, date: dateString }) => (
  <>
    <div>Name: {name}</div>
    <div>Created: {date.fromString(dateString).format('DD.MM.YYYY h:mm A')}</div>
  </>
);
